import React from 'react';
import ChannelBasicInfoComponent from './channel-basic-info.component';
import { ChannelConfigurationInfoComponent } from './channel-configuration-info.component';
import { ChannelBannerInfoComponent } from './channel-banner-info.component';
import _ from 'lodash';
import TabContainer from '../../../../../../common/components/tab/containers/tab.containers';
import QRCodeMapComponent from './qr-code-map.component';

function ChannelComponent ({ back,handleFormSubmit, openConfirmation, handleChannelBannerItemChange, deleteSelectedChannelBanner, getIsChannelBannerDeletable, channelBanner, changeBannerImage, changeImage, handleInnerbasicFormChange, onInnerFormChange, selectedChannel, stores }: any) {
  
  const tabItems=[
    {
        id:1,
        title:'Store',
        component: <ChannelBasicInfoComponent
        handleInnerbasicFormChange={handleInnerbasicFormChange}
        selectedChannels={selectedChannel}
        stores={stores}
    />,
    isVisible:true,
    },
    {
        id:2,
        title:'Configurations',
        component:  <ChannelConfigurationInfoComponent
        changeImage={changeImage}
        onInnerFormChange={onInnerFormChange}
        selectedChannels={selectedChannel}
    />,
        isVisible:true,
    },
    {
        id:3,
        title:'Channel Banners',
        component:  <ChannelBannerInfoComponent
        changeBannerImage={changeBannerImage}
        channelBanner={channelBanner}
        deleteSelectedChannelBanner={deleteSelectedChannelBanner}
        getIsChannelBannerDeletable={getIsChannelBannerDeletable}
        handleChannelBannerItemChange={handleChannelBannerItemChange}
        openConfirmation={openConfirmation}
    />,
        isVisible:true,
    },
    {
        id:4,
        title:'QR code Mapping',
        component:<QRCodeMapComponent
        selectedChannel={selectedChannel}
        onInnerFormChange={onInnerFormChange}
       />,
        isVisible:true,
    },
  ]

  return (<>
      <div className="flex flex-col items-center w-full px-5 overflow-auto h-screen">
       
     
       <TabContainer tabItems={tabItems} />
    
       <div className='flex w-full justify-end items-end'>
         <button
               onClick={back}
               type='button'
               className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
              >
               Back
              </button>
              <button
             className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
               onClick={handleFormSubmit}
             
               type="submit"
           >
             Save
           </button>
         </div>
        </div>
     </>
  );
}
export default ChannelComponent;
